/**
 * Describes how a limit is enabled and where its configuration values live.
 *
 * A `LimitSchema` defines:
 * - flag: the boolean flag (checkboxes) that enables/disables the limit
 * - keys: the flow parameter keys associated with that limit in the config
 * - customFormField: optional custom formik fields used to store temp value
 */
type LimitSchema = {
    flag: string;
    keys: readonly string[];
    customFormField?: readonly string[];
};

export const PARTICIPATION_LIMIT_SCHEMA: LimitSchema[] = [
    {
        flag: 'minAge',
        keys: ['minAge'],
    },
    {
        flag: 'calendarDay',
        keys: [
            'participationLimitCalendarDatesRange',
            'participationLimitCalendarDatesLimit',
            'participationLimitCalendarDatesTimeZone',
        ],
    },
    {
        flag: 'rolling',
        keys: [
            'participationLimit',
            'participationLimitTime',
            'participationLimitTimeZone',
            'participationLimitStartEndDatesRange',
        ],
    },
    {
        flag: 'lifetime',
        keys: ['participationLifetimeLimit'],
    },
    {
        flag: 'calendarCycle',
        keys: ['participationCalendarCycleLimit'],
    },
];

export const WINNING_LIMIT_SCHEMA: readonly LimitSchema[] = [
    {
        flag: 'instantWinLimitPerConfiguration',
        keys: ['instantWinLimitPerConfiguration'],
    },
    {
        flag: 'instantWinLimitPerHourFlag',
        keys: ['instantWinLimitPerTimeInterval', 'instantWinLimitPerTimeIntervalValue'],
    },
    {
        flag: 'instantWinCalendarCycleLimitFlag',
        keys: ['instantWinCalendarCycleLimit'],
        customFormField: ['winningLimits']
    }
];